import React, { useEffect } from "react";
import { scroller } from "react-scroll";
import Heading from "../components/Heading";
import Partner from "../components/Partner";
import About from "../components/About";
import Contact from "../components/Contact";
import Navbar from "../components/Navbar";
import HowItWorks from "../components/Howitworks";
import { useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet';

<Helmet>
  <title>ReconPro – AI GST Reconciliation & Ledger Automation</title>
  <meta name="description" content="ReconPro is an AI-powered platform for automating GST reconciliation and ledger mapping with Xero, MYOB, and Handi files." />
  <meta name="keywords" content="GST reconciliation, ledger automation, Xero, MYOB, Handi, AI accounting, tax automation" />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://reconpro.ai" />
</Helmet>

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div className="max-w-full overflow-x-hidden">
      <Navbar />
      <Heading />
      <Partner />
      <HowItWorks />
      <About />
      <Contact />
    </div>
  );
}
